import SummaryViewFactory from '@/Factories/SummaryViewFactory';
import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';
import SummaryViewFactoryTuple from '@/Factories/SummaryViewFactoryTuple';

export default abstract class AsyncSummaryViewFactory extends SummaryViewFactory implements IAsyncElementProvider, IAsyncTupleProvider<SummaryViewFactoryTuple> {
    public getSummaryView(): JQuery {
        throw new Error(`'getSummaryView' is not supported in '${ this.constructor?.name ?? 'AsyncSummaryViewFactory' }'`);
    }

    public async getTupleAsync(): Promise<SummaryViewFactoryTuple> {
        if (this.tuple)
            return this.tuple;

        const $view = await this.getElementAsync();
        this.tuple = new SummaryViewFactoryTuple(this, $view);
        return this.tuple;
    }

    public abstract getElementAsync(): Promise<JQuery>;
}